import Layout from './layout';
import Sider from './Sider';
Layout.Sider = Sider;
export default Layout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/layout/index.js
// module id = 742
// module chunks = 1